import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { UserService } from '../../../../services/user';
import { ProfileService } from '../../../../services/profile.service';
import { LoginService } from '../../../Authentication/auth/login.service';
import { ResigteringService } from '../../../Authentication/auth/resigtering.service';
import { PetServices } from '../../../../services/petservices';

@Component({
  selector: 'app-bookclinicservice',
  templateUrl: './bookclinicservice.component.html',
  styleUrl: './bookclinicservice.component.scss'
})
export class BookclinicserviceComponent implements OnInit {
  bookingForm!: FormGroup;

  contentReady: boolean = false;
  isAr: boolean = false;

  serviceId!: number;
  service: any = null;

  token: any = localStorage.getItem('token');
  tokenExists: boolean = false;
  userId: any = null;

  client_name: string = '';
  phone_number: string = '';

  minDate: string = '';

  petTypes = [
    { value: 'cat', ar: 'قط', en: 'Cat' },
    { value: 'dog', ar: 'كلب', en: 'Dog' },
  ];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private petServices: PetServices,
    private userService: UserService,
    private profileService: ProfileService,
    private loginService: LoginService,
    private registeringService: ResigteringService
  ) {}

  ngOnInit(): void {
    this.isAr = localStorage.getItem('language') === 'ar';
    this.token = localStorage.getItem('token');
    this.tokenExists = !!this.token;
    this.minDate = this.getMinDateTime();

    this.initForm();
    this.checkForToken();
    this.getServiceIdFromRoute();

    this.bookingForm.patchValue({
      from_website: this.getCurrentPageUrl()
    });

    if (this.tokenExists) {
      this.getUserData();
    }
  }

  initForm(): void {
    const guestNameValidators = this.tokenExists ? [] : [Validators.required];
    const guestPhoneValidators = this.tokenExists
      ? []
      : [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(/^01[0-9]{9}$/)
        ];

    this.bookingForm = this.fb.group({
      pet_service_id: ['', Validators.required],
      pet_type: ['cat', Validators.required],
      client_name: ['', guestNameValidators],
      phone_number: ['', guestPhoneValidators],
      booking_date: ['', Validators.required],
      from_website: [this.getCurrentPageUrl()]
    });
  }

  checkForToken(): void {
    this.loginService.token$.subscribe((token) => {
      this.tokenExists = token != null;
    });
  }

  getServiceIdFromRoute(): void {
    const idFromParams = this.route.snapshot.paramMap.get('id');
    const idFromQuery = this.route.snapshot.queryParamMap.get('service_id');

    const id = Number(idFromParams || idFromQuery);

    if (!id) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'الخدمة غير موجودة' : 'Service not found',
        timer: 1500,
        showConfirmButton: false
      });

      this.router.navigateByUrl('/clinic');
      return;
    }

    this.serviceId = id;

    this.bookingForm.patchValue({
      pet_service_id: this.serviceId
    });

    this.loadService(this.serviceId);
  }

  loadService(id: number): void {
    this.contentReady = true;

    this.petServices.getById(id).subscribe({
      next: (res: any) => {
        this.service = res?.data ?? res;
        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل تحميل الخدمة' : 'Failed to load service',
          confirmButtonText: this.isAr ? 'تمام' : 'OK'
        });

        this.router.navigateByUrl('/clinic');
      }
    });
  }

  getUserData(): void {
    this.contentReady = true;

    this.userService.getUserId().subscribe({
      next: (data: any) => {
        this.userId = data['user_id'];

        this.profileService.getuserinfo(this.userId).subscribe({
          next: (res: any) => {
            this.contentReady = false;

            this.client_name = res?.first_name || res?.name || '';
            this.phone_number = res?.phone || '';

            this.bookingForm.patchValue({
              client_name: this.client_name,
              phone_number: this.phone_number
            });
          },
          error: () => {
            this.contentReady = false;
          }
        });
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  submitBooking(): void {
    if (this.bookingForm.invalid) {
      this.bookingForm.markAllAsTouched();

      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'كمل بيانات الحجز' : 'Complete booking data',
        timer: 1500,
        showConfirmButton: false
      });

      return;
    }

    if (this.tokenExists) {
      this.loggedInBooking();
    } else {
      this.createUserThenBooking();
    }
  }

  loggedInBooking(): void {
    const formValue = this.bookingForm.value;

    const clientName = this.client_name || formValue.client_name;
    const phoneNumber = this.phone_number || formValue.phone_number;

    if (!clientName || !phoneNumber || !this.userId) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'بيانات حسابك ناقصة' : 'Your account data is incomplete',
        text: this.isAr ? 'جرب تسجل دخول مرة تانية' : 'Please login again',
        confirmButtonText: this.isAr ? 'تمام' : 'OK'
      });
      return;
    }

    const payload = this.buildBookingPayload(this.userId, clientName, phoneNumber);
    this.storeBooking(payload);
  }

  createUserThenBooking(): void {
    const formValue = this.bookingForm.value;

    const clientName = formValue.client_name;
    const phoneNumber = formValue.phone_number;

    const registerData = new FormData();

    registerData.append('first_name', clientName);
    registerData.append('last_name', clientName);
    registerData.append('username', phoneNumber);
    registerData.append('password', phoneNumber);
    registerData.append('password_confirmation', phoneNumber);
    registerData.append('phone', phoneNumber);
    registerData.append('type', '9');

    this.contentReady = true;

    this.registeringService.user_Resigter(registerData).subscribe({
      next: (res: any) => {
        const newUserId = res?.user?.id;

        this.userId = newUserId;
        this.client_name = clientName;
        this.phone_number = phoneNumber;

        if (res?.token) {
          this.loginService.setToken(res.token);
          localStorage.setItem('token', res.token);
        }

        const payload = this.buildBookingPayload(newUserId, clientName, phoneNumber);
        this.storeBooking(payload);
      },
      error: (err) => {
        const usernameTaken =
          err?.status === 422 &&
          (
            err?.error?.message === 'The username has already been taken.' ||
            err?.error?.errors?.username?.includes('The username has already been taken.')
          );

        if (usernameTaken) {
          Swal.fire({
            icon: 'info',
            title: this.isAr ? 'رقم التليفون مسجل بالفعل' : 'Phone number already registered',
            text: this.isAr
              ? 'سيتم تسجيل الدخول واستكمال الحجز'
              : 'Logging you in and completing the booking',
            timer: 1600,
            showConfirmButton: false,
          });

          this.loginAndContinueBooking(clientName, phoneNumber);
          return;
        }

        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'حصلت مشكلة في إنشاء المستخدم' : 'Error while creating user',
          text: this.isAr ? 'راجع البيانات أو كلم الدعم' : 'Please check data or contact support',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      },
    });
  }

  loginAndContinueBooking(clientName: string, phoneNumber: string): void {
    const body = {
      username: phoneNumber,
      password: phoneNumber
    };

    this.loginService.user_login(body).subscribe({
      next: (res: any) => {
        if (res?.token) {
          this.loginService.setToken(res.token);
          localStorage.setItem('token', res.token);
        }

        localStorage.setItem('username', phoneNumber);

        const idFromLogin = res?.user?.id;

        if (idFromLogin) {
          this.userId = idFromLogin;

          const payload = this.buildBookingPayload(idFromLogin, clientName, phoneNumber);
          this.storeBooking(payload);
          return;
        }

        this.userService.getUserId().subscribe({
          next: (data: any) => {
            this.userId = data['user_id'];

            const payload = this.buildBookingPayload(this.userId, clientName, phoneNumber);
            this.storeBooking(payload);
          },
          error: () => {
            this.contentReady = false;

            Swal.fire({
              icon: 'error',
              title: this.isAr
                ? 'تم تسجيل الدخول لكن تعذر جلب بيانات المستخدم'
                : 'Logged in but failed to load user data',
              confirmButtonText: this.isAr ? 'تمام' : 'OK',
            });
          }
        });
      },
      error: () => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr
            ? 'رقم التليفون مسجل لكن فشل تسجيل الدخول'
            : 'Phone exists but login failed',
          text: this.isAr
            ? 'جرب تسجل دخول يدويًا'
            : 'Please login manually',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        }).then(() => {
          this.router.navigateByUrl('/Login');
        });
      },
    });
  }

  buildBookingPayload(userId: any, clientName: string, phoneNumber: string): any {
    const formValue = this.bookingForm.value;

    return {
      pet_service_id: Number(formValue.pet_service_id),
      user_id: userId ? Number(userId) : null,
      pet_type: formValue.pet_type,
      client_name: clientName,
      phone_number: phoneNumber,
      booking_date: this.formatDateForLaravel(formValue.booking_date),
      from_website: this.getCurrentPageUrl()
    };
  }

  storeBooking(payload: any): void {
    this.contentReady = true;

    this.petServices.createBooking(payload).subscribe({
      next: () => {
        this.contentReady = false;

        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم حجز الخدمة بنجاح' : 'Service booked successfully',
          text: this.isAr
            ? 'هنكلمك لتأكيد المعاد'
            : 'We will contact you to confirm the appointment',
          confirmButtonText: this.isAr ? 'تمام' : 'OK'
        }).then(() => {
          this.router.navigateByUrl('/clinic');
        });
      },
      error: (err) => {
        this.contentReady = false;
        console.error(err);

        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'فشل حجز الخدمة' : 'Booking failed',
          text: this.isAr
            ? 'راجع البيانات وحاول تاني'
            : 'Please check your data and try again',
          confirmButtonText: this.isAr ? 'تمام' : 'OK'
        });
      }
    });
  }

  onlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;

    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  formatDateForLaravel(value: string): string {
    if (!value) return value;

    return value.replace('T', ' ') + ':00';
  }

  getMinDateTime(): string {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  }

  getCurrentPageUrl(): string {
    if (typeof window !== 'undefined' && window.location) {
      return window.location.href;
    }

    return 'website';
  }

  get serviceTitle(): string {
    if (!this.service) return '';

    if (this.isAr) {
      return this.service?.name_ar || this.service?.title_ar || this.service?.name || 'خدمة عيادة';
    }

    return this.service?.name_en || this.service?.title_en || this.service?.name || 'Clinic Service';
  }

  get serviceDescription(): string {
    if (!this.service) return '';

    if (this.isAr) {
      return this.service?.description_ar || this.service?.desc_ar || this.service?.description || '';
    }

    return this.service?.description_en || this.service?.desc_en || this.service?.description || '';
  }

  get servicePrice(): any {
    return this.service?.pricea;
  }


getDateTimeParts(value: any): any {
  if (!value) return null;

  let cleanValue = String(value)
    .replace('T', ' ')
    .replace('Z', '')
    .split('.')[0]
    .trim();

  const match = cleanValue.match(
    /^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2})/
  );

  if (!match) return null;

  return {
    year: match[1],
    month: match[2],
    day: match[3],
    hours: match[4],
    minutes: match[5],
  };
}

formatDateTimeForDateTimeLocal(value: any): string {
  const parts = this.getDateTimeParts(value);

  if (!parts) {
    return this.getMinDateTime();
  }

  return `${parts.year}-${parts.month}-${parts.day}T${parts.hours}:${parts.minutes}`;
}

formatDateTimeView(value: any): string {
  const parts = this.getDateTimeParts(value);

  if (!parts) return '—';

  let hours = Number(parts.hours);
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedHours = String(hours).padStart(2, '0');

  if (this.isAr) {
    const arAmPm = ampm === 'AM' ? 'ص' : 'م';
    return `${parts.year}-${parts.month}-${parts.day} ${formattedHours}:${parts.minutes} ${arAmPm}`;
  }

  return `${parts.year}-${parts.month}-${parts.day} ${formattedHours}:${parts.minutes} ${ampm}`;
}

openDatePicker(input: HTMLInputElement): void {
  this.bookingForm.controls['booking_date'].markAsTouched();

  input.focus();

  if ((input as any).showPicker) {
    (input as any).showPicker();
  } else {
    input.click();
  }
}

get bookingDateDisplay(): string {
  const value = this.bookingForm?.controls['booking_date']?.value;

  if (!value) {
    return this.isAr ? 'اختار التاريخ والوقت' : 'Choose date and time';
  }

  return this.formatDateTimeView(value);
}
}